import {DecimalPipe} from '@angular/common'
import {Component, input} from '@angular/core'

@Component({
  selector: 'spb-kalp-item',
  templateUrl: './kalp-item.component.html',
  styleUrls: ['./kalp-item.component.scss'],
  imports: [DecimalPipe]
})
export class KalpItemComponent {

  /**
   * The name to display for the value
   */
  readonly label = input('')

  /**
   * The value to display, will be formatted as number.
   */
  readonly value = input(0)

  /**
   * A pretty optional index for the hosting component
   * to keep track of this item.
   */
  readonly index = input(0)

  /**
   * If this is a sum rather than an item
   */
  readonly summary = input(false)

  /**
   * Put a + or minus before item?
   */
  readonly plusMinus = input('')

  readonly decimals = input('0')
}
